// source: https://github.com/facebook/react/issues/13029#issuecomment-445480443
export const mergeRefs = (...refs) => (ref) => {
    refs.forEach(resolvableRef => {
        if (!resolvableRef)
            return;
        if (typeof resolvableRef === "function")
            resolvableRef(ref);
        else
            resolvableRef.current = ref;
    });
};
//# sourceMappingURL=utils.js.map